module.exports = __webpack_public_path__ + "img/goes-gray.16454a2c.png";